import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, memberEncryptionTypeParser, memberRoleParser, memberScimStatusParser, memberStatusParser, principalProviderParser, } from '#validation';
import { userRefSchema } from '#web-service-api/user';
import { FilespaceAdminForSchema } from './filespace-admin-for.schema';
import { memberGroupsSchema } from './member-groups.schema';
export const MemberInfoResponseSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    user: userRefSchema,
    role: memberRoleParser,
    status: memberStatusParser,
    provider: principalProviderParser,
    scimStatus: memberScimStatusParser,
    encryptionType: memberEncryptionTypeParser,
    filespaceAdminFor: FilespaceAdminForSchema.nullish(),
    joinedOn: dateParser(),
    updatedAt: dateParser(),
    reinviteNeeded: z.boolean(),
    pendingInvitation: z
        .object({
        id: z.string(),
        eInvitationSecretByAdminKey: z.string(),
    })
        .optional(),
    groups: memberGroupsSchema.optional(),
});
export class MemberInfoResponseDto extends createZodDto(MemberInfoResponseSchema) {
}
